<template>
  <div class="reset-secret-wrapper">
    <article v-if="canRequestReset && !isSuccess">
      <h1>Recover your API secret</h1>
      <p>
        Don’t worry, it happens to the best of us.<br />
        Kindly note that once you reset your API keys, any integrations or
        access that utilizes your current API secret will no longer be
        available. <br />
        <br />
        You are trying to reset the secret of
        <span>{{ getMerchantName() }}</span
        >.
      </p>

      <button @click="sendResetRequest">
        Reset {{ getMerchantName() }}'s API secret
      </button>
    </article>
    <article v-if="canRequestReset && isSuccess" class="isSuccessful">
      <h1>Successfully reset</h1>
      <p>
        Your API keys have been reset.
        <br />
        Your new API keys and ID information are sent to:
        <span>{{ getEmail() }}</span>
        It might take up to a few minutes for you to receive the email. If you
        encounter any issues please try again.
      </p>
      <button @click="goBackToDashboard()">Go back to the dashboard</button>
    </article>
    <article v-if="!canRequestReset">
      <h1>Sorry</h1>
      <p>
        The merchant {{ getMerchantName() }} is not allowed to reset it's API
        secret.
      </p>
      <button @click="goBackToDashboard()">Go back to the dashboard</button>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isSuccess: false,
      canRequestReset: false,
    };
  },
  methods: {
    getEmail() {
      return this.activeMerchantGetter.email;
    },
    getMerchantName() {
      return this.activeMerchantGetter.merchant_name;
    },
    sendResetRequest() {
      // at this point we already cheked if the user has the rights
      const merchantKey =
        this.activeMerchantGetter && this.activeMerchantGetter.merchant_key;
      this.apiResetSecret(merchantKey).then((res) => {
        if (res === 200) {
          this.isSuccess = true;
          return true;
        } else {
          this.$vs.notify({
            title: 'Error',
            text: res,
            color: 'danger',
          });
        }
      });
    },
    checkResetRequestRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      this.canRequestReset = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'reset_client_secret',
        'W'
      );
      return this.canRequestReset;
    },
    goBackToDashboard() {
      this.$router.push('/home');
    },
  },
  computed: {
    ...mapGetters(['activeMerchantGetter', 'currentActiveEntityAdminGetter']),
  },
  watch: {
    activeMerchantGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: activeMerchantGetter: update detected',
          newValue,
          oldValue
        );
      this.updateResetRequestRights();
    },
  },
  mounted() {
    this.checkResetRequestRights();
  },
};
</script>

<style lang="scss">
.reset-secret-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 48px;
  article {
    max-width: 600px;
    background-color: white;
    border: 1px solid #afafaf;
    border-radius: 10px;
    padding: 40px 32px;
    display: flex;
    flex-flow: column;
    transition: ease-in-out 0.5s;
    h1 {
      margin-bottom: 24px;
    }
    button {
      margin: 24px auto 0 auto;
      padding: 12px 24px;
      background-color: rgba($color: #0a5692, $alpha: 0.8);
      color: white;
      border-radius: 6px;
      border: none;
      &:hover {
        cursor: pointer;
        background-color: rgba($color: #0a5692, $alpha: 1);
        transition: ease-in-out 0.2s;
      }
    }
    p > span {
      font-weight: bold;
    }

    &.isSuccessful {
      p > span {
        display: block;
        margin-top: 12px;
        margin-bottom: 12px;
        font-weight: bold;
        text-align: center;
      }
      button {
        background-color: #28a745;
        &:hover {
          background-color: #15712b;
        }
      }
    }
  }
}
</style>
